"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 组织架构模块
var _default = exports.default = {
  getBizOrgInfoList: function getBizOrgInfoList(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/bizOrgInfo/list',
      method: 'post',
      data: data
    });
  },
  getDetail: function getDetail(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/bizOrgInfo/query/' + id,
      method: 'post'
    });
  },
  import: function _import(data, type) {
    return (0, _request.default)({
      module: 'CORE',
      url: "/protected/bizOrgInfo/import/".concat(type),
      method: 'post',
      data: data
    });
  },
  export: function _export(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/bizOrgInfo/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};